<template>
  <div class="wf-search-results-section">
    <div class="wf-search-results-section-inner">
      <div
        v-if="collections && collections.length > 0"
        class="
          wf-search-results
          wf-search-results-view-mode-swatch
          wf-search-results-tile-size-small
        "
      >
        <result-item
          v-for="item in collections"
          :key="item.id"
          :className="'wf-search-result-scope-' + item.id"
          :imageUrl="item.featureImage || ''"
          :imageAltText="item.featureImageAltText || ''"
          :link="$helpers.getCollectionOverviewUrl(item.name)"
          :title="$helpers.matchText(item.name, searchTerm)"
          :showViewButton="true"
        />
        <pc-load-more
          v-if="
            totalCollectionPages > collectionsPageNumber ||
            (fetchingCollections && collections.length === 0)
          "
          :loadMore="onLoadMore"
        />
      </div>
      <p v-if="collections.length === 0 && !fetchingCollections">
        {{ $resourceString["common.noResults"] }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ResultItem from "./pc-result-item.vue";
import PcLoadMore from "../common/pc-loading-more.vue";

export default {
  components: {
    ResultItem,
    PcLoadMore,
  },
  computed: {
    ...mapGetters({
      searchTerm: "searchResultsPage/searchTerm",
      collections: "searchResultsPage/collections",
      totalCollectionPages: "searchResultsPage/totalCollectionPages",
      collectionsPageNumber: "searchResultsPage/collectionsPageNumber",
      fetchingCollections: "searchResultsPage/fetchingCollections",
    }),
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      fetchCollectionsResults: "searchResultsPage/fetchCollectionsResults",
      setCollectionsPageNumber: "searchResultsPage/setCollectionsPageNumber",
    }),
    onLoadMore() {
      if (this.fetchingCollections) {
        return;
      }
      this.setCollectionsPageNumber(this.collectionsPageNumber + 1);
      this.fetchCollectionsResults();
    },
  },
  watch: {
    searchTerm: {
      handler: function () {
        if (!this.searchTerm) {
          return;
        }
        this.fetchCollectionsResults();
      },
      deep: true,
    },
  },
};
</script>
